import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, Inject, PLATFORM_ID} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {isPlatformBrowser} from '@angular/common';
import {isNullOrUndefined} from 'util';
import {Subscription} from 'rxjs';

export interface MinMax {
  min: any;
  max: any;
}

@Component({
  selector: 'lps-range-input',
  templateUrl: './range-input.component.html'
})
export class RangeInputComponent implements OnInit, OnDestroy {

  previousValues = {min: '', max: ''};
  errorMessage = 'O mínimo não pode ser maior que o máximo';

  @Input() minId = 'min';
  @Input() maxId = 'max';
  @Input() minPrefix = '';
  @Input() maxPrefix = '';
  @Input() minPlaceholder = '';
  @Input() maxPlaceholder = '';
  @Input() mask = 'separator.0';
  @Input() value: MinMax = {min: '', max: ''};
  @Output() valueChange: EventEmitter<MinMax> = new EventEmitter<MinMax>();
  @Output() onBlur: EventEmitter<BlurEvent> = new EventEmitter<BlurEvent>();

  form: FormGroup;

  formSubscription = new Subscription();

  lock = true;
  isBrowser: boolean;

  constructor(
    private formBuilder: FormBuilder,
    @Inject(PLATFORM_ID) platformId: object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit() {
    this.buildForm();
    this.listenValueChanges();
  }

  buildForm(): void {
    this.form = this.formBuilder.group(
      {
        min: [this.value.min],
        max: [this.value.max]
      },
      {
        validators: this.lesserThan,
        updateOn: 'blur'
      }
    );
  }

  listenValueChanges(): void {
    this.formSubscription = this.form.valueChanges.subscribe((v) => {
      if (this.form.valid) {
        this.valueChange.emit(v);
      } else {
        this.valueChange.emit({ ...v, error: true});
      }
    });
  }

  removeError() {
    this.form.errors && (this.form.errors.notLesserThan = false);
  }

  ngOnDestroy() {
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

  unset({ target }) {
    const iOS = this.isBrowser && !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    iOS && this.lock && target.blur();
    this.lock = false;
  }

  lesserThan = (group: FormGroup) => {
    const min = Number(group.get('min').value);
    let max = Number(group.get('max').value);
    if (group.get('max').value === '') {
      max = null;
    }
    if (!isNullOrUndefined(min) && !isNullOrUndefined(max)) {
      return max >= min ? null : {notLesserThan: true};
    }
    return null;
  }

  isPositive($event: KeyboardEvent) {
    return $event.key !== '-';
  }

  blur(field: string) {
    const value = this.form.get(field).value;
    const previousValue = this.previousValues[field];
    if (previousValue !== value) {
      const blurEvent = this.createBlurEventWith(field, value);
      this.onBlur.emit(blurEvent);
    }
    this.previousValues[field] = value;
  }

  createBlurEventWith(field: string, value: string): BlurEvent {
    return {
      field,
      value,
      error: {
        hasError: this.form.errors ? this.form.errors.notLesserThan : false,
        message: this.errorMessage.toLowerCase().replace(/ /g, '-')
      }
    };
  }
}

interface BlurEvent {
  field: string;
  value: string;
  error: BlurEventError;
}

interface BlurEventError {
  hasError: boolean;
  message: string;
}
